export const minWidthToDisplay = 1
export const minWidthToDisplayText = 12
export const rowHeight = 22
export const textHeight = 20

// http://gka.github.io/palettes/#colors=#37AFA9,#FEBC38|steps=25|bez=0|coL=0
export const backgroundColorGradient = [
    '#37afa9',
    '#4bb0a5',
    '#5ab0a1',
    '#67b19d',
    '#72b299',
    '#7cb295',
    '#86b390',
    '#8fb48c',
    '#97b488',
    '#9fb584',
    '#a6b680',
    '#aeb67b',
    '#b5b777',
    '#bcb772',
    '#c2b86e',
    '#c9b869',
    '#cfb965',
    '#d5b960',
    '#dbba5b',
    '#e1ba56',
    '#e7bb50',
    '#edbb4b',
    '#f3bb45',
    '#f8bc3f',
    '#febc38',
]
export const colorGradient = ['#000000']
